import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import {
  IconButton,
  Popover,
  Input,
  ClickAwayListener,
} from "@material-ui/core";
import styled from "styled-components";

export default function ColumnSearch({
  onSearchTextChange,
  defaultValue = "",
  onColumnSearchClosed = () => {},
}) {
  const [isShown, setIsShown] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const onSearchIconClick = (e) => {
    setIsShown(true);
    setAnchorEl(e.target);
  };
  const handleClose = (e) => {
    setIsShown(false);
    onColumnSearchClosed();
  };

  return (
    <React.Fragment>
      <StyledIconButton size="small" onClick={onSearchIconClick}>
        <StyledSearchIcon fontSize="small" />
      </StyledIconButton>
      <Popover
        open={isShown}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Input
            autoFocus
            defaultValue={defaultValue}
            type="search"
            style={{ margin: 5 }}
            placeholder="Search..."
            onChange={(e) => onSearchTextChange(e.target.value)}
          />
        </ClickAwayListener>
      </Popover>
    </React.Fragment>
  );
}

const StyledIconButton = styled(IconButton)`
  cursor: default !important;
`;

const StyledSearchIcon = styled(SearchIcon)`
  cursor: default !important;
`;